var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPointDestination({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6 13H8V21H6V13Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H12V7H14V9Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H16V11H14V9Z",
    fill: "#727272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3H15V5H19V15H12V13H6V3ZM8 5H10V7H8V5ZM12 7H10V9H8V11H10V9H12V11H14V13H16V11H18V9H16V7H14V5H12V7Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPointDestination);
export default __webpack_public_path__ + "static/media/ic_action_point_destination.96dc2bd3c09ac652bf74fe35ab712339.svg";
export { ForwardRef as ReactComponent };